/**
 * Dev login UI (quick org accounts, inline OTP codes) — local Vite dev only.
 */
export const isDevLoginEnabled =
  import.meta.env.DEV || import.meta.env.VITE_ENABLE_DEV_LOGIN === "true";
